<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="4" style="margin-bottom: 15px">
          <!-- 年级树 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="gradeData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expand-all="true"
              @node-click="chooseGrade"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="19" style="margin-bottom: 15px">
          <ele-data-table ref="table" :config="table" height="calc(100vh - 200px)" highlight-current-row>
            <template>
              <el-table-column type="index" width="45" align="center" fixed="left" show-overflow-tooltip />
              <el-table-column prop="className" label="班级名称" sortable="custom" show-overflow-tooltip />
              <el-table-column prop="teacherName" label="教师姓名" sortable="custom" show-overflow-tooltip />
              <el-table-column prop="time" label="打卡时间" sortable="custom" show-overflow-tooltip />
            </template>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
  import { getAllGradeTree } from '@/config/api';

  export default {
    name: '',
    data() {
      return {
        loading: true, // 加载状态
        gradeData: [],
        choose: [],
        table: {
          // 表格配置
          url: '/school/teacherClass/todayClass',
          where: {
            gradeId: null,
          },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
      };
    },
    mounted() {
      this.queryGradeTree();
    },
    methods: {
      // 获取年级树
      queryGradeTree() {
        this.loading = true;
        getAllGradeTree().then((res) => {
          this.loading = false;
          if (res.data.resCode == 200) {
            this.gradeData.push(res.data.data);
            setTimeout(() => {
              this.chooseGrade(this.gradeData[0].children[0].children[0]);
            }, 100);
          } else {
            this.$message.error(res.data.resMsg || '获取数据失败');
          }
        });
      },
      /* 选择数据 */
      chooseGrade(row) {
        if (row.orgType === 3) {
          this.$refs.orgTree.setCurrentKey(row.id);
          let obj = {
            gradeId: row.id.slice(1),
          };
          this.table.where = obj;
          this.$refs.table.reload();
        }
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 35px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
